import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-check",
  "use": "rt-base-check-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-check\"><path d=\"M912 192h-69.9c-9.8 0-19.1 4.5-25.1 12.1L404.7 723.3 207 474.3c-6.1-7.7-15.3-12.1-25.1-12.1H112c-6.7 0-10.4 7.7-6.3 12.8l273.9 344.9c12.8 16.1 37.4 16.1 50.3 0l488.4-615.2c4.1-5 0.4-12.7-6.3-12.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/check.svg
// module id = 1691
// module chunks = 137